import makeStyles from "@mui/styles/makeStyles";
import { darkGrey, lightBlueActive } from "../../../../constants/colors";

export const TAB_HEIGHT = 50;
export const INDICATOR_HEIGHT = 3;

export const useTabsStyles = makeStyles({
  root: {
    boxShadow: "inset 0 1px 0 0 #efefef",
    overflow: "visible",
  },
  fixed: {
    overflow: "visible !important",
  },
  indicator: {
    height: INDICATOR_HEIGHT,
    transform: "translateY(-49px)",
    backgroundColor: darkGrey,
  },
  flexContainer: {
    minWidth: "80px",
  },
});

export const useTabItemStyles = makeStyles({
  root: {
    textTransform: "capitalize",
    lineHeight: "inherit",
    padding: "0px 12px",
    minWidth: 0,
    color: "#000000",
    minHeight: TAB_HEIGHT + INDICATOR_HEIGHT,
    flexDirection: "row",
    fontFamily: "Roboto",
    "& svg, .MuiSvgIcon-root": {
      fontSize: 15,
      marginRight: 8,
      marginBottom: 0,
    },
    transition: "background-color 0.3s",
    opacity: 0.8,
  },
  selected: {
    fontWeight: "bold",
    opacity: 1,
    background: lightBlueActive,
  },
  disabled: {
    opacity: "0.05 !important",
  },
});
